// import * as _ from 'lodash';

export const copyOnlyMatchingProperties = (lhs, rhs) => {
    let output = Object.assign({}, lhs);
    Object
        .keys(rhs)
        .filter(key => output.hasOwnProperty(key))
        .map(key => output[key] = rhs[key]);

    return output;
}

// empty guid: '00000000-0000-0000-0000-000000000000'
export const emptyGuid = '00000000-0000-0000-0000-000000000000';

// export const deepClone = (objectToClone) => {
//     return _.cloneDeep(objectToClone);

//     if (objectToClone === null)
//         return null;
// };

export const isNullOrUndefined = (obj) => {
    return obj === undefined || obj === null;
}

export const isNullOrEmpty = (objArray) => {
    if (isNullOrUndefined(objArray))
        return true;

    if (!Array.isArray(objArray))
        throw Error('Object must be an array');

    return objArray.length === 0;
}

export const isNullOrEmptyString = (obj) => {
    if (isNullOrUndefined(obj))
        return true;

    if (typeof obj !== 'string')
        throw Error('Object must be string');

    return obj.length === 0;
}
